// React imports.
import React from "react";

import { Assessment1StepsEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";

const Assessment1QuestionsUnderReporting = ({fuelType, state, showDontKnowNote }) => (
    <div>
        <ol>
            <li>
                One or more of the vendors did not include all necessary  
                charges, such as usage charges, fixed monthly charges,  
                or third-party supplier charges, in the billing amounts  
                they reported to you. If that occurred, you would need  
                to ask them to provide all necessary charges in the  
                billing amounts they report.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors reported data for the heating season only.
                If that occurred, you would need to ask them to report data for the whole year.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors included some households who had less than  
                12 months of data. If that occurred, you would need to ask them to  
                identify which households had a full year of data and which households  
                were served for only part of the year.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors offers some type of rate discount to some
                of their LIHEAP recipient customers. If that occurred, it is important
                for you to know, but the data are still valid.
                <br/><br/>
            </li>
        </ol>

        Let's walk through each of these issues so that you can assess whether any
        of them might be a problem for your data.&nbsp;
        {showDontKnowNote === true
          &&<span>
                Please answer each of the questions below. Depending on your response, each
                question may ask you to outline an action item to help you address the issue.
                <br/><br/>
                <strong>
                    If you don't know the answer to a question please indicate "Don't Know"
                    and provide your plans to acquire this information from IT department or
                    programming staff in the response box.
                </strong>
            </span>}
        <br/><br/>

        <ol>
            {/*USAGE*/}
            <li>
                Do your electric vendors indicate they are including energy usage charges
                (e.g. variable costs) in the expenditure amounts they report to you?<br/>
                <label>
                    <input type="radio"
                        name="IncludingEnergyUseChargesFlag"
                        id="IncludingEnergyUseChargesFlag_true"
                        value="Y"
                        checked={fuelType.IncludingEnergyUseChargesFlag === 'Y'}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingEnergyUseChargesFlag"
                        id="IncludingEnergyUseChargesFlag_false"
                        value="N"
                        checked={fuelType.IncludingEnergyUseChargesFlag === 'N'}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingEnergyUseChargesFlag"
                        id="IncludingEnergyUseChargesFlag_dk"
                        value="U"
                        checked={fuelType.IncludingEnergyUseChargesFlag === 'U'}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludingEnergyUseChargesFlag === 'Y'
                  && <span><strong>No Action Needed</strong>  All energy usage charges should be included in the expenditure amounts that your vendors report to you. </span>}
                {fuelType.IncludingEnergyUseChargesFlag === 'N'
                  &&
                      <span>
                          <strong>Requires followup.</strong>&nbsp;
                          The expenditure amounts reported by your electric vendors  
                          should include energy usage and other variable charges.  
                          If your vendors are not including this information it will
                          cause your average electric bill for  {fuelType.description}&nbsp; households
                          to be underreported. 
                          <br/><br/>
                          Please indicate your plans to address this issue in the box below
                          <textarea  name="IncludingEnergyUseChargesDesc"
                              id="IncludingEnergyUseChargesDesc" style={{width:"100%"}}
                              value={fuelType.IncludingEnergyUseChargesDesc}
                              onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                      </span>}
                  {fuelType.IncludingEnergyUseChargesFlag === 'U'
                  &&
                      <span>
                          <strong>Requires followup.</strong>&nbsp;
                          You need to know whether or not your electric vendors are including usage
                          and variable charges in the amounts they report to you in order to fully
                          assess the reliability of your data. You may need to review your vendor
                          agreements or discuss with your IT department to obtain this information. 
                          <br/><br/>
                          Please indicate your plans for obtaining this information in the box below.
                          <textarea  name="IncludingEnergyUseChargesDesc"
                              id="IncludingEnergyUseChargesDesc" style={{width:"100%"}}
                              value={fuelType.IncludingEnergyUseChargesDesc}
                              onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                      </span>}
                <br/><br/>
            </li>

            {/*DELIVERY*/}
            <li>
                Do your electric vendors indicate they are including energy delivery, fixed charges, and taxes
                (e.g. transmission, regular monthly charges) in the expenditure amounts they report to you?
                <br/>

                <label>
                    <input type="radio"
                        name="IncludingEnergyDeliveryChargesFlag"
                        id="IncludingEnergyDeliveryChargesFlag_true"
                        value="Y"
                        checked={fuelType.IncludingEnergyDeliveryChargesFlag === "Y"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingEnergyDeliveryChargesFlag"
                        id="IncludingEnergyDeliveryChargesFlag_false"
                        value="N"
                        checked={fuelType.IncludingEnergyDeliveryChargesFlag === "N"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingEnergyDeliveryChargesFlag"
                        id="IncludingEnergyDeliveryChargesFlag_dk"
                        value="U"
                        checked={fuelType.IncludingEnergyDeliveryChargesFlag === "U"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>

                <br/ >
                {fuelType.IncludingEnergyDeliveryChargesFlag === "Y"
                  && <span>
                      <strong>No Action Needed. </strong>  
                      Energy delivery charges, fixed charges, and taxes should be included in the
                      expenditure amounts that your vendors report to you.  
                  </span>}

                {fuelType.IncludingEnergyDeliveryChargesFlag === "N"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Energy delivery charges, fixed charges, and taxes should be
                        included in the expenditure amounts that your vendors report.  
                        If your vendors are not including this information it will
                        cause your average electric bill for   {fuelType.description}&nbsp; households to be too low. 
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="IncludingEnergyDeliveryChargesDesc"
                        id="IncludingEnergyDeliveryChargesDesc" style={{width:"100%"}}
                        value={fuelType.IncludingEnergyDeliveryChargesDesc}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                {fuelType.IncludingEnergyDeliveryChargesFlag === "U"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        You need to know whether or not your electric vendors are including  
                        delivery charges, fixed charges, and taxes in the amounts they report  
                        to you in order to fully assess the reliability of your data.  
                        You may need to review your vendor agreements or discuss with your
                        IT department to obtain this information. 
                        <br/><br/>
                        Please indicate your plans for obtaining this information in the box below.
                        <textarea  name="IncludingEnergyDeliveryChargesDesc"
                        id="IncludingEnergyDeliveryChargesDesc" style={{width:"100%"}}
                        value={fuelType.IncludingEnergyDeliveryChargesDesc}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*IncludeSupplierCharges*/}
            <li>
                Do your electric vendors indicate they are including third-party supplier charges,
                where applicable, in the expenditure amounts they report to you? 
                <br/>
                <label>
                    <input type="radio"
                        name="IncludeSupplierChargesFlag"
                        id="IncludeSupplierChargesFlag_true"
                        value="Y"
                        checked={fuelType.IncludeSupplierChargesFlag === "Y"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludeSupplierChargesFlag"
                        id="IncludeSupplierChargesFlag_false"
                        value="N"
                        checked={fuelType.IncludeSupplierChargesFlag === "N"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludeSupplierChargesFlag"
                        id="IncludeSupplierChargesFlag_dk"
                        value="U"
                        checked={fuelType.IncludeSupplierChargesFlag === "U"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludeSupplierChargesFlag === "Y"
                  && <span>
                      <strong>No Action Needed. </strong>  
                      Third -party supplier charges, where applicable, should be included in the
                      expenditure amounts that your vendors report to you.  
                  </span>}
                {fuelType.IncludeSupplierChargesFlag === "N"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Third-party supplier charges should be included in the expenditure amounts
                        that your vendors report. If your vendors are not including this information
                        it will cause your average electric bill
                        for  {fuelType.description}&nbsp; households to be too low.  
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="IncludeSupplierChargesDesc"
                        id="IncludeSupplierChargesDesc" style={{width:"100%"}}
                        value={fuelType.IncludeSupplierChargesDesc}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                {fuelType.IncludeSupplierChargesFlag === "U"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        You need to know whether or not your electric vendors are including  
                        delivery charges, fixed charges, and taxes in the amounts they report
                        to you in order to fully assess the reliability of your data.
                        You may need to review your vendor agreements or discuss with
                        your IT department to obtain this information. 
                        <br/><br/>
                        Please indicate your plans for obtaining this information in the box below.
                        <textarea  name="IncludeSupplierChargesDesc"
                        id="IncludeSupplierChargesDesc" style={{width:"100%"}}
                        value={fuelType.IncludeSupplierChargesDesc}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>
            {/*COMPLETE 12 MONTH*/}
            <li>
                Do your electric vendors indicate they are including the total expenditure amount for a complete
                12-month period (not only cooling or heating seasons)?
                <br/>
                <label>
                    <input type="radio"
                        name="IncludingComplete12MonthFlag"
                        id="IncludingComplete12MonthFlag_true"
                        value="Y"
                        checked={fuelType.IncludingComplete12MonthFlag === 'Y'}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingComplete12MonthFlag"
                        id="IncludingComplete12MonthFlag_false"
                        value="N"
                        checked={fuelType.IncludingComplete12MonthFlag === 'N'}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingComplete12MonthFlag"
                        id="IncludingComplete12MonthFlag_dk"
                        value="U"
                        checked={fuelType.IncludingComplete12MonthFlag === 'U'}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludingComplete12MonthFlag === "Y"
                  && <span><strong>No action needed</strong>Your electric vendors should be tracking and reporting electric billing data for a full 12-month period. </span>}
                {fuelType.IncludingComplete12MonthFlag === "N"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Your electric vendors should be tracking and reporting electric billing data
                        for a full 12-month period. If your vendors are including reporting data for
                        a shorter period (for example just the heating or cooling season) this will
                        cause your reported average electric bill values to be too low. 
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="IncludingComplete12MonthDesc"
                            id="IncludingComplete12MonthDesc" style={{width:"100%"}}
                            value={fuelType.IncludingComplete12MonthDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                  {fuelType.IncludingComplete12MonthFlag === "U"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        You need to know whether or not your electric vendors are providing a full
                        12 months of billing data for your assisted households in order to perform
                        a full assessment. You may need to review your vendor agreements or discuss
                        with your IT department to obtain this information.
                        <br/><br/>
                        Please indicate your plans for obtaining this information in the box below.
                        <textarea  name="IncludingComplete12MonthDesc"
                            id="IncludingComplete12MonthDesc" style={{width:"100%"}}
                            value={fuelType.IncludingComplete12MonthDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>
            {/*INDICATING LESS THAN 12 MONTH*/}
            <li>
                Do your electric vendors confirm they are indicating if an account’s expenditure data
                represents less than 12-months, such as due to the account closing or moving?
                <br/>
                <label>
                    <input type="radio"
                        name="IndicatingLessThan12MonthFlag"
                        id="IndicatingLessThan12MonthFlag_true"
                        value="Y"
                        checked={fuelType.IndicatingLessThan12MonthFlag === "Y"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IndicatingLessThan12MonthFlag"
                        id="IndicatingLessThan12MonthFlag_false"
                        value="N"
                        checked={fuelType.IndicatingLessThan12MonthFlag === "N"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IndicatingLessThan12MonthFlag"
                        id="IndicatingLessThan12MonthFlag_dk"
                        value="U"
                        checked={fuelType.IndicatingLessThan12MonthFlag === "U"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>

                <br/ >
                {fuelType.IndicatingLessThan12MonthFlag === "Y"
                  && <span>
                      <strong>No action needed</strong>  
                      Your electric vendors should be marking individual records that do not
                      represent a full 12 months of data for one of the listed reasons.
                  </span>}
                {fuelType.IndicatingLessThan12MonthFlag === "N"
                  &&<span><strong>Requires followup.</strong>&nbsp;
                        Your electric vendors should be marking individual records that do not
                        represent a full 12 months of data for one of the listed reasons.
                        If they are not marking these records they might be removed
                        from the dataset before calculating the average bill, which would
                        cause your reported average to be too low. 
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="IndicatingLessThan12MonthDesc"
                            id="IndicatingLessThan12MonthDesc" style={{width:"100%"}}
                            value={fuelType.IndicatingLessThan12MonthDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                  {fuelType.IndicatingLessThan12MonthFlag === "U"
                    &&<span><strong>Requires followup.</strong>&nbsp;
                      You need to know whether or not your electric vendors are marking  
                      records for households that do not represent a full 12 months  
                      of data in order to perform a full assessment. You may need  
                      to review your vendor agreements or discuss with your IT
                      department to obtain this information. 
                      <br/><br/>
                      Please indicate your plans for obtaining this information in the box below.
                      <textarea  name="IndicatingLessThan12MonthDesc"
                          id="IndicatingLessThan12MonthDesc" style={{width:"100%"}}
                          value={fuelType.IndicatingLessThan12MonthDesc}
                          onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*AFTER DISCOUNTS*/}
            <li>
                Are your electric vendors reporting expenditure amounts after low-income discounts have been applied?
                <br/>
                <label>
                    <input type="radio"
                        name="ReportingAfterDiscountsFlag"
                        id="ReportingAfterDiscountsFlag_true"
                        value="Y"
                        checked={fuelType.ReportingAfterDiscountsFlag === "Y"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="ReportingAfterDiscountsFlag"
                        id="ReportingAfterDiscountsFlag_false"
                        value="N"
                        checked={fuelType.ReportingAfterDiscountsFlag === "N"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="ReportingAfterDiscountsFlag"
                        id="ReportingAfterDiscountsFlag_dk"
                        value="U"
                        checked={fuelType.ReportingAfterDiscountsFlag === "U"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>
                <br/ >

                {fuelType.ReportingAfterDiscountsFlag === "Y"
                  && <span>
                      <strong>No action needed </strong>
                      Your electric vendors should be sending bill data after low-income discount
                      have been applied. However, this could be the reason that your reported
                      average annual bill for  {fuelType.description}&nbsp; households
                      is lower than we would expect based on the information available in the ACS. 
                </span>}
                {fuelType.ReportingAfterDiscountsFlag === "N"
                  &&<span>
                        <strong>Requires followup.</strong>&nbsp;
                        Your electric vendors should be sending bill data after low-income
                        discount have been applied. This does not explain why your
                        reported average annual electric bill is too low, but it is still
                        an issue that needs to be addressed. 
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="ReportingAfterDiscountsDesc"
                            id="ReportingAfterDiscountsDesc" style={{width:"100%"}}
                            value={fuelType.ReportingAfterDiscountsDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                  {fuelType.ReportingAfterDiscountsFlag === "U"
                  &&<span>
                        <strong>Requires followup.</strong>&nbsp;
                        You need to know whether or not your electric vendors are marking records
                        for households that do not represent a full 12 months of data in order
                        to perform a full assessment. You may need to review your vendor
                        agreements or discuss with your IT department to obtain this information. 
                        <br/><br/>
                        Please indicate your plans for obtaining this information in the box below.
                        <textarea  name="ReportingAfterDisnbsp;countsDesc"
                            id="ReportingAfterDiscountsDesc" style={{width:"100%"}}
                            value={fuelType.ReportingAfterDiscountsDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>
            {(state.assessment1ShowCatchallQuestionUnder(fuelType) === true && showDontKnowNote === true)
            &&
                <div>
                    It appears that your potential data reliability issue cannot be
                    explained by the most common reasons we have found
                    for why states' estimates differ from the ACS.
                    Please contact APPRISE to discuss other potential
                    explanations for this discrepancy. If you have any
                    ideas about what might be causing the discrepancy
                    please document it in the response box below.                        
                    <textarea  name="OtherReasonDesc"
                        id="OtherReasonDesc" style={{width:"100%"}}
                        value={fuelType.OtherReasonDesc}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                </div>
            }


        </ol>
    </div>
);

export default Assessment1QuestionsUnderReporting;
